import React from "react";
import PageHero from "../components/PageHero";
import ResourcesGrid from "../components/ResourcesGrid";
import CtaBanner from "../components/CtaBanner";

function Resources() {
  return (
    <>
      <PageHero
        eyebrow="Resources"
        title="From the product documentation"
        subtitle="MPeoples HRMS is documented end to end — from APIs to deployment and troubleshooting. Ask us for the full documentation set."
      />

      <section className="section">
        <div className="container">
          <ResourcesGrid />
        </div>
      </section>

      <CtaBanner />
    </>
  );
}

export default Resources;
